<template>
  <div class="order-fee-container">
    <div class="margin-top">
      <el-table :data="aOrderDetailFeeInfo.fees" border style="width: 100%" v-loading="loading">
        <el-table-column type="index" :label="$t('aOrderDetailFee.serial')" align="center" width="80">
        </el-table-column>
        <el-table-column prop="feeName" :label="$t('aOrderDetailFee.feeName')" align="center" min-width="150">
        </el-table-column>
        <el-table-column prop="price" :label="$t('aOrderDetailFee.amount')" align="center" width="120">
        </el-table-column>
        <el-table-column prop="payPrice" :label="$t('aOrderDetailFee.paymentAmount')" align="center" width="120">
        </el-table-column>
        <el-table-column prop="payWayName" :label="$t('aOrderDetailFee.paymentMethod')" align="center" width="150">
        </el-table-column>
        <el-table-column :label="$t('aOrderDetailFee.status')" align="center" width="120">
          <template slot-scope="scope">
            {{ scope.row.state == '1001' ? $t('aOrderDetailFee.unpaid') : $t('aOrderDetailFee.paid') }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" :label="$t('aOrderDetailFee.paymentTime')" align="center" width="180">
        </el-table-column>
      </el-table>

      <el-row class="margin-top">
        <el-col :span="24" class="text-right">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getOrderFees } from '@/api/order/aOrderDetailApi'

export default {
  name: 'AOrderDetailFee',
  data() {
    return {
      aOrderDetailFeeInfo: {
        fees: [],
        orderId: '',
        prodNameLike: '',
        personNameLike: ''
      },
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.aOrderDetailFeeInfo.orderId = params.orderId
      this.loadOrderFeeData()
    },
    loadOrderFeeData() {
      this.loading = true
      const params = {
        orderId: this.aOrderDetailFeeInfo.orderId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      getOrderFees(params).then(response => {
        this.aOrderDetailFeeInfo.fees = response.data
        this.pagination.total = response.records
        this.loading = false
      }).catch(error => {
        console.error('获取订单费用失败:', error)
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadOrderFeeData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadOrderFeeData()
    }
  }
}
</script>

<style scoped>
.order-fee-container {
  padding: 15px;
}

.margin-top {
  margin-top: 15px;
}

.text-right {
  text-align: right;
}
</style>